import React from "react";
import styled from "styled-components";
import "./styles/TutorComponent.css";

const BannerWrapper = styled.div`
  width: 100%;
`;

function TutorComponent() {
  return (
    <BannerWrapper>
      <div className="tutor-banner">
        {/*  Subheading */}
        <div className="tutor-banner-heading">
          <h1 className="banner-heading">
            Bangladesh's #1 <br />
            Smart Tutor <br />
            Network
          </h1>
          <p className="sub-tut">
            Join countries <br />
            highest verified-tutor platform
          </p>
        </div>

        <div className="tutor-buttons">
          <button
            type="button"
            className="tutor-join-button"
            onClick={() =>
              (window.location.href = "https://tn.goatteachers.com/")
            }
          >
            <strong>Find Tutor</strong>
          </button>

          <button
            type="button"
            className="tutor-join-button"
            onClick={() =>
              (window.location.href =
                "https://tn.goatteachers.com/tutor-submission")
            }
          >
            <strong>Become Tutor</strong>
          </button>
        </div>
      </div>
    </BannerWrapper>
  );
}

export default TutorComponent;
